import { render, staticRenderFns } from "./StudentIndex.vue?vue&type=template&id=04be8c18&scoped=true&"
import script from "./StudentIndex.vue?vue&type=script&lang=js&"
export * from "./StudentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be8c18",
  null
  
)

export default component.exports